import React, { useState, useEffect } from "react"
import { AuthorizableLink } from '@reactiveonline/frontend_shared_components'

import MiniCart from "./MiniCart"
import GlobalProductSearch from '../shared/GlobalProductSearch'

export default function HeaderIcons({ appProps, order }) {
  const { GlobalProductSearch } = appProps
  const [isCheckout, setIsCheckout] = useState(window.location.href.indexOf("checkout") > -1)
  const [currentOrder, setCurrentOrder] = useState(order || appProps.order)
  const [selectedDropMenu, setSelectedDropMenu] = useState(null)
  const [openMenu, setOpenMenu] = useState(false)

  const localePrefix = appProps.currentLocale ? `/${appProps.currentLocale}` : ''
  const { translations, registrationEnabled } = appProps
  const profileData = [
    { title: translations.account.manage_account, icon: 'fa-user',          read: false, timestamp: null, path: appProps.accountPath },
    { title: translations.account.order_history,  icon: 'fa-table-list',    read: false, timestamp: null, path: appProps.orderHistoryPath },
    { title: translations.account.billing,        icon: 'fa-address-book',  read: false, timestamp: null, path: appProps.billingPath },
    { title: translations.account.privacy_policy, icon: 'fa-shield-halved', read: false, timestamp: null, path: appProps.privacyPolicyPath },
    { title: translations.account.delete_account, icon: 'fa-eraser',        read: false, timestamp: null, path: appProps.deleteAccountPath },
    { title: translations.general.logout,         icon: 'fa-right-from-bracket', read: false, timestamp: null, path: appProps.logoutPath, requestType: 'delete' },
  ]

  let loginData = [{ title: translations.account.login_button, icon: null, read: false, timestamp: null, path: `${localePrefix}/account` }]

  if (appProps.user && appProps.user.belongsToCompany) {
    profileData.unshift({ title: translations.company.company, icon: 'fa-building', read: false, timestamp: null, path: appProps.companyInfoPath })
  }
  if(registrationEnabled) {
    loginData.push({ title: translations.account.register_button, icon: null, read: false, timestamp: null, path: `${localePrefix}/account` })
  }

  function escFunction(event){
    if (event.key === "Escape") {
      setOpenMenu(false)
    }
  }

  useEffect( ()=>{
    document.addEventListener("keydown", escFunction, false);
  },[openMenu])

  return (
    <>
      <div className="header-icons-container">
        <ul>
          <GlobalProductSearch
            appProps={ appProps }
          />
          { !isCheckout &&
            <li className="cart-dropmenu mini_cart">
              <div id="mini-cart-ajax-container">
                <MiniCart
                  appProps={ appProps }
                  lineItemsCount={ appProps.lineItemsCount }
                />
              </div>
            </li>
          }
          <li className="account">
            <AuthorizableLink
              appProps={ appProps }
              profileData={ profileData }
              linkClass="account_icon my-account"
              linkRef={ appProps.accountPath }
            />
          </li>
        </ul>
      </div>
    </>
  )
}
